// GlobalState.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { Block } from "./Game/Block/Block";
import { v4 as uuidv4 } from 'uuid';

// Create the context
const GlobalContext = createContext();

// Create a provider component
export const GlobalProvider = ({ children }) => {

  const BASE_LENGTH_PX = 20;
  const TRAY_BLOCK_COUNT = 3;

  const [ mousePos, setMousePos ] = useState({ x: 0, y: 0 });
  const [ gameOver, setGameOver ] = useState(false); 
  const [ score, setScore ] = useState(0);
  /** @type  {[{shape:[][], key:String}]} */
  const [ selectedBlock, setSelectedBlock ] = useState(false);
  const [ blocks, setBlocks ] = useState([...Array(TRAY_BLOCK_COUNT).keys()].map((i)=>{
    const id = uuidv4()
    return (<Block params={{index:i, id:id}} key={id}></Block>)
  }));

  
  useEffect(() => {
    // Event handler for mouse movement
    const handleMouseMove = (event) => {
      setMousePos({ x: event.clientX, y: event.clientY });
    };


    // Attach listener
    window.addEventListener("pointermove", handleMouseMove, { passive: true });
    //window.addEventListener("mousedown", handleClick);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("pointermove", handleMouseMove);
      //window.removeEventListener("mousedown", handleClick);
    };
  }, []);

  useEffect(()=>{
    if(gameOver === true){
      alert(`Sticky Binca got you with her STICKY HANDS! You scored ${score} Bincas!`);
      window.location.reload();
    }
  }, [gameOver])

  return (
    <GlobalContext.Provider value={{ BASE_LENGTH_PX, mousePos, selectedBlock, setSelectedBlock, blocks, setBlocks, score, setScore, gameOver, setGameOver }} >
      {children}
    </GlobalContext.Provider>
  );
};

// Custom hook for easy access
export const useGlobalState = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalProvider");
  }
  return context;
};